import { inject } from "@angular/core";
import { AuthService } from "../../../auth/auth.service";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { RedirectPathService } from "../redirect/redirect-path.service";
import { CookieService } from "ngx-cookie-service";


export function authGuard(): CanActivateFn {
    return async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const authService: AuthService = inject(AuthService)

        if (authService.isAuthenticated()) {
            return true;
        } else if (authService.urlContainsAuthToken(route)) {
          return true;
        } else {
            const redirectPathService: RedirectPathService = inject(RedirectPathService)
            const router: Router = inject(Router)

            const wantedUrl = state.url;

            redirectPathService.store(wantedUrl)
            await router.navigate(['/login']);
            return false;
        }
    };
}
export function alreadyLoggedGuard(): CanActivateFn {
    return async () => {
        const authService: AuthService = inject(AuthService)

        if (authService.isAuthenticated()) {
            const router: Router = inject(Router)
            await router.navigate(['/home']);
            return false;
        } else {
            return true;
        }
    };
}